export default __webpack_public_path__ + "static/media/img1.716b6e72.png";